export const EMAIL_VERIFICATION_PERIOD_DAYS = 30;
export const MAX_OTP_RESEND_ATTEMPTS = 3;
export const OTP_LENGTH = 4;
